import type { FC } from "react";
import Actions from "../components/actions/Actions";
import AddFab from "../components/actions/AddFab";
import type { UserContext } from "../auth/auth";
import OrderProductsCsvExport from "./csvExport/OrderProductsCsvExport";
import OrdersCsvExport from "./csvExport/OrdersCsvExport";

interface Props {
  readonly userContext: UserContext;
  readonly onAction: () => void;
}

const OrdersActions: FC<Props> = ({ userContext, onAction }) => {
  const role = userContext?.role;
  const isAdminOrAgent = role === "ADMIN" || role === "AGENT";
  const csvExportEnabled = role === "ADMIN" || (role === "AGENT" && !userContext.customPrivileges.cannotExportOrders);
  return (
    <Actions>
      {csvExportEnabled && <OrdersCsvExport />}
      {csvExportEnabled && <OrderProductsCsvExport />}
      {isAdminOrAgent && <AddFab label="dodaj zamówienie" onClick={onAction} />}
    </Actions>
  );
};

export default OrdersActions;
